import React from 'react';
import { DataLayer } from '../../../lib/types';

interface LayerHeaderProps {
  layer: DataLayer;
}

export const LayerHeader: React.FC<LayerHeaderProps> = ({ layer }) => (
  <div className="space-y-2">
    <div className="flex items-start justify-between gap-3">
      <h3 className="flex-1 min-w-0 font-anton font-normal text-[32px] leading-[1.15] tracking-[0.005em] uppercase text-figma-text m-0 break-words">
        {layer.displayName}
      </h3>
      {layer.status === 'live' && (
        <span className="flex-shrink-0 mt-1 px-2.5 py-0.5 text-[10px] font-roboto-mono uppercase tracking-wider rounded-full bg-figma-mint/15 border border-figma-mint/40 text-figma-mint">
          Live
        </span>
      )}
    </div>
    <p className="text-body font-roboto text-figma-ink-soft leading-relaxed">
      {layer.description}
    </p>
  </div>
);
